import { render, staticRenderFns } from "./UserDetail.vue?vue&type=template&id=2f04ce76&scoped=true"
import script from "./UserDetail.vue?vue&type=script&lang=js"
export * from "./UserDetail.vue?vue&type=script&lang=js"
import style0 from "./UserDetail.vue?vue&type=style&index=0&id=2f04ce76&prod&scoped=true&lang=scss"
import style1 from "./UserDetail.vue?vue&type=style&index=1&id=2f04ce76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f04ce76",
  null
  
)

export default component.exports